import { ReactNode } from "react";
import { DialogContent, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  body: {
    overflowY: "initial",
    padding: "8px 25px"
  }
}));

const ModalBody = (props: { children: ReactNode }) => {
  const { children } = props;

  const classes = useStyles();

  return <DialogContent className={classes.body}>{children}</DialogContent>;
};

export default ModalBody;
